// UI
export const NotificationDuration = 6000;

// Requests
export const FetchTimeout = 6000;

// Rides
export const RideTypes = [
    'running',
    'hiking',
    'bike',
    'walk'
];

export const DefaultRideType = RideTypes[0];

export const ElevationRideTypes = [
    'hiking',
    'bike'
];

export const PaceRideTypes = [
    'running',
    'walk'
];

// Pace profiles scale the estimated duration (sport = faster, tourist = slower).
// Keep the order/values in sync with Constant::PACE_PROFILES (Ruby).
export const PaceProfiles = [
    'tourist',
    'standard',
    'sport'
];

export const DefaultPaceProfile = 'standard';

export const PaywallSoftFunctionalities = [
    'map_max_route_computation_count'
];

export const paywallTier = (functionality) => (
    PaywallSoftFunctionalities.includes(functionality) ? 'soft' : 'hard'
);

// Home onboarding: ordered contextual steps that guide a new visitor from drawing a route
// to saving it (and creating an account). Driven by mapStore progress, non-blocking.
export const HomeOnboardingSteps = ['draw', 'data', 'features', 'save'];
// Disabled for now: the bottom card duplicates the on-map contextual helpers, takes too
// much room (esp. mobile) and covers the scroll feedback button. Flip back to true to
// re-enable (the stepped tour still works). See the lighter alternatives discussed.
export const HomeOnboardingEnabled = false;
export const HomeOnboardingStorageKey = 'home_onboarding';

export const RideLevels = [
    'level_undefined',
    'very_easy',
    'easy',
    'medium',
    'difficult',
    'very_difficult'
];

export const RideVisibilities = [
    'everyone',
    'only_me'
];

export const RouteComputationTypes = [
    'foot',
    'hike',
    // 'hike_fastest',
    'bike',
    'mtb',
    'car',
    // 'car_fastest'
];

// Pois
export const PlanDateTypes = [
    'unplanned',
    'week',
    'month',
    'year',
    'date',
    'completed'
];

// export const rideProcessingTimer = 1000;

// export const rideCountLimit = 500;

// Map
export const MapLayers = {
    MAP_PLANNER: 'map_planner',
    MAP_PLANNER_OUTDOOR: 'map_planner_outdoor',
    MAPBOX_SATELLITE: 'mapbox_satellite',
    IGN: 'ign',
    SWISS_TOPO: 'swiss_topo',
    OS_MAPS: 'os_maps',
    USGS_TOPO: 'usgs_topo',
    OPEN_TOPO_MAP: 'open_topo_map',
    OPEN_CYCLE_MAP: 'open_cycle_map',
    OPEN_STREET_MAP: 'open_street_map'
    // MAPBOX_OUTDOOR: 'mapbox_outdoor',
    // MAPBOX_STREET: 'mapbox_street',
};

export const MapLayerNames = {
    map_planner: 'MAP PLANNER',
    map_planner_outdoor: 'MAP PLANNER OUTDOOR',
    mapbox_outdoor: 'MAPBOX',
    mapbox_street: 'MAPBOX STREET',
    mapbox_satellite: 'MAPBOX SATELLITE',
    open_street_map: 'OSM',
    open_cycle_map: 'OPEN CYCLE MAP',
    swiss_topo: 'SWISSTOPO',
    os_maps: 'OS MAPS',
    usgs_topo: 'USGS TOPO',
    open_topo_map: 'OPEN TOPO MAP',
    ign: 'IGN'
};

export const RideTypeToRouteType = {
    running: 'foot',
    hiking: 'hike',
    bike: 'bike',
    walk: 'foot',
};

export const RouteTypeToRideType = {
    foot: 'running',
    hike: 'hiking',
    bike: 'bike',
    mtb: 'bike',
    car: 'walk'
};

export const MapIsochroneDistances = [
    5000,
    10000,
    15000,
    20000
];

export const MapIsochroneDurations = [
    900,
    1800,
    3600,
    7200
];

// Products
export const Products = {
    EXPLORER: 'explorer',
    EXPLORER_DISCOVER: 'explorer-discover'
};

// Search
export const AutocompleteLimit = 8;
export const MaxSearchRate = 200;

// Autocomplete
export const AutocompleteSuggestionsLimit = 20;

// Metasearch
export const MetaSearchLimit = 20;

// Uploads
export const UploadMaxWidth = 2560;
export const UploadMaxHeight = 2560;
